import styled from 'styled-components'
import FontAwesome from 'react-fontawesome'
import Button from 'components/Button'

const StyledButton = styled(Button)`
  padding: 0;
  margin-left: 5px;
  background: none;
  color: var(--white);
  border-color: var(--white);
  font-size: 16px;
  width: 34px;
  height: 34px;

  &:hover {
    background: var(--white);
    color: var(--main-color);
  }

  .expanded & {
    color: ${(props) => (props.active ? 'var(--main-color)' : 'var(--gray)')};
    border-color: ${(props) =>
      props.active ? 'var(--main-color)' : 'var(--gray)'};
  }
`

const ThumbsButton = ({ active, handleClick, direction, className }) => (
  <StyledButton active={active} onClick={handleClick} className={className}>
    <FontAwesome name={direction === 'up' ? 'thumbs-up' : 'thumbs-down'} />
  </StyledButton>
)

export default ThumbsButton
